import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormValidationSchema = Yup.object().shape({
    email: Yup.string().required(validationMessages.required).email(validationMessages.email),
    password: Yup.string().required(validationMessages.required),
    marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required),
    marketing_sms: Yup.boolean(),

    phone: Yup.object({
        code: Yup.number(),
        number: Yup.string()
    })
        .nullable()
        .when("marketing_sms", {
            is: true,
            then: (schema) =>
                schema.shape({
                    code: Yup.number().required(validationMessages.required),
                    number: Yup.string().required(validationMessages.required)
                })
        })
});
import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormValidationSchema = Yup.object().shape({
    email: Yup.string().required(validationMessages.required).email(validationMessages.email),
    password: Yup.string().required(validationMessages.required),
    marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required),
    marketing_sms: Yup.boolean(),

    phone: Yup.object({
        code: Yup.number(),
        number: Yup.string()
    })
        .nullable()
        .when("marketing_sms", {
            is: true,
            then: (schema) =>
                schema.shape({
                    code: Yup.number().required(validationMessages.required),
                    number: Yup.string().required(validationMessages.required)
                })
        })
});
